import HTTP from '@/api/HTTP';

const URL_BASE = 'gescom/ProduitFaceAnonyme/';

export async function PGetAllFaceByLigneCommandeAnonymeAsync(hash, query) {
  const dataQuery = {
    ...query,
    typesDevisCommandeFacture: ['Commande'],
    etatsDevisCommandeFacture: ['Enregistre', 'Facture', 'FactureePartiellement', 'Commande'],
  };
  // FV
  const response = await HTTP.post(URL_BASE + 'PGetAllFaceByLigneCommandeAnonymeAsync', {
    query: dataQuery,
    sorting: '',
    skipCount: 0,
    maxResultCount: 999999,
  }, { params: { hash } });
  return response;
}

export const NOTHING = '';
